if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.useDtcCart = this.shouldUseDtcCart();
        this.cart = this.useDtcCart
          ? null
          : document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (this.useDtcCart || document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      shouldUseDtcCart() {
        if (!window.DtcCartDrawerController || !document.querySelector('dtc-cart-drawer')) {
          return false;
        }

        // Gift card recipient forms require the full FormData POST flow.
        if (this.form.querySelector('[name="properties[__shopify_send_gift_card_to_recipient]"]')) {
          return false;
        }

        return true;
      }

      setSubmitLoading(isLoading) {
        const spinner = this.querySelector('.loading__spinner');

        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          if (spinner) spinner.classList.remove('hidden');
          return;
        }

        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      }

      async onDtcSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const controller = window.DtcCartDrawerController;
        const trigger = evt.submitter || this.submitButton;
        const variantId = controller.getVariantId(trigger);

        this.handleErrorMessage();

        if (!variantId) {
          controller.showError('Please select a product option before adding to cart.');
          controller.open();
          return;
        }

        this.setSubmitLoading(true);
        const quantity = controller.getQuantity(trigger);

        try {
          const lineItem = await controller.add(variantId, quantity);

          if (
            lineItem &&
            window.vGtm &&
            window.vGtm.cart &&
            typeof window.vGtm.cart.trackAdd === 'function'
          ) {
            window.vGtm.cart.trackAdd(
              lineItem,
              quantity,
              Object.assign(controller.resolveAddToCartGtm(trigger), { trigger: trigger })
            );
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: lineItem,
          });

          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            quickAddModal.hide(true);
          }
        } catch (error) {
          controller.showError(error.message);
          controller.open();
          this.handleErrorMessage(error.message);
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: error.message,
            message: error.message,
          });
          this.error = true;
        } finally {
          this.setSubmitLoading(false);
        }
      }

      onSubmitHandler(evt) {
        if (this.useDtcCart) {
          return this.onDtcSubmitHandler(evt);
        }

        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
